import React from "react";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalBtnWithIcons = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal button with start and end icons"}
        value={
          '<Button variant={"tonal"} color={"inherit"} startIcon={<ArrowLeftIcon />} endIcon={<ArrowRightIcon />}>\n' +
          "            Label\n" +
          "          </Button>"
        }
      >
        <Button
          variant={"tonal"}
          color={"inherit"}
          startIcon={<ArrowLeftIcon />}
          endIcon={<ArrowRightIcon />}
        >
          Label
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalBtnWithIcons;
